import { useTranslation } from "react-i18next";
import PageShell, { Breadcrumb } from "@/components/feature/PageShell";

export default function PartnersHuaqiao() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <section className="relative pt-24 pb-20 bg-gradient-to-b from-secondary-900 to-secondary-800 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20partnership%20and%20collaboration%20pattern%20with%20interlocking%20geometric%20shapes%2C%20jade%20green%20background%2C%20modern%20institutional%20aesthetic%2C%20flowing%20connected%20lines%2C%20warm%20subtle%20lighting%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=partner-hq-hero-01&orientation=landscape')] bg-cover bg-center opacity-15"></div>
        <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8">
          <Breadcrumb items={[{ label: t("nav.partners") }, { label: t("partners.huaqiao.title") }]} />
          <div className="mt-6 max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              {t("partners.huaqiao.title")}
            </h1>
            <p className="mt-4 text-lg text-background-100/80 leading-relaxed">
              {t("partners.huaqiao.subtitle")}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-4">{t("partners.huaqiao.intro")}</h2>
                <p className="text-foreground-700 leading-relaxed">{t("partners.huaqiao.intro.p1")}</p>
                <p className="text-foreground-700 leading-relaxed mt-4">{t("partners.huaqiao.intro.p2")}</p>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-4">{t("partners.huaqiao.areas")}</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[0, 1, 2, 3].map((i) => (
                    <div key={i} className="bg-background-100 rounded-lg p-5">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 mb-3">
                        <i className={["ri-search-line", "ri-graduation-cap-line", "ri-global-line", "ri-database-2-line"][i] + " text-lg"}></i>
                      </div>
                      <h3 className="font-heading font-semibold text-foreground-900 mb-1.5">{t(`partners.huaqiao.area.${i}.title`)}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{t(`partners.huaqiao.area.${i}.desc`)}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-4">{t("partners.huaqiao.results")}</h2>
                <div className="space-y-3">
                  {[0, 1, 2, 3].map((i) => (
                    <div key={i} className="flex gap-3">
                      <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-bold mt-0.5">
                        {i + 1}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">{t(`partners.huaqiao.result.${i}`)}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <aside className="space-y-6">
              <div className="bg-secondary-50 rounded-lg p-6 border border-secondary-200">
                <h3 className="font-heading font-semibold text-secondary-800 mb-3">{t("partners.huaqiao.sidebar.title")}</h3>
                <div className="w-full h-40 rounded-md overflow-hidden mb-3">
                  <img
                    src="https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/1c3e8ef2-28ac-446d-93d3-a41d09a5a22b_compressed_building.webp"
                    alt={t("partners.huaqiao.sidebar.title")}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="space-y-2 text-sm">
                  <p className="text-foreground-700"><strong className="text-foreground-900">{t("partners.huaqiao.sidebar.founded")}：</strong>{t("partners.huaqiao.sidebar.foundedVal")}</p>
                  <p className="text-foreground-700"><strong className="text-foreground-900">{t("partners.huaqiao.sidebar.location")}：</strong>{t("partners.huaqiao.sidebar.locationVal")}</p>
                  <p className="text-foreground-700"><strong className="text-foreground-900">{t("partners.huaqiao.sidebar.authority")}：</strong>{t("partners.huaqiao.sidebar.authorityVal")}</p>
                  <p className="text-foreground-700"><strong className="text-foreground-900">{t("partners.huaqiao.sidebar.type")}：</strong>{t("partners.huaqiao.sidebar.typeVal")}</p>
                </div>
              </div>

              <div className="bg-primary-50 rounded-lg p-6 border border-primary-200">
                <h3 className="font-heading font-semibold text-primary-800 mb-3">{t("partners.huaqiao.sidebar.other")}</h3>
                <nav className="space-y-2">
                  <p className="text-sm text-foreground-500">{t("partners.huaqiao.sidebar.other.desc")}</p>
                </nav>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </PageShell>
  );
}